import { Component, OnInit } from '@angular/core';
import { RulesComponent } from '../rules.component';

@Component({
  selector: 'app-m-rules',
  templateUrl: './m-rules.component.html',
  styleUrls: ['./m-rules.component.css']
})
export class MRulesComponent extends RulesComponent implements OnInit {

  ngOnInit(): void {
  }

}
